import { render, staticRenderFns } from "./headerImage.vue?vue&type=template&id=771272c6&scoped=true"
import script from "./headerImage.vue?vue&type=script&lang=js"
export * from "./headerImage.vue?vue&type=script&lang=js"
import style0 from "./headerImage.vue?vue&type=style&index=0&id=771272c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771272c6",
  null
  
)

export default component.exports